const $ = require("jquery")

export const onInitialClientRender = () => {
  $(document).ready(function () {
  });
}
